var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "col-12",
      attrs: { id: "recurring-reminders-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleSubmit.apply(null, arguments)
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("b-card", [
        _c("ul", { staticClass: "list-group list-group-flush bt-0" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t(
                      "settings.accountTab.tabs.applicationRecurringReminders"
                    )
                  ) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c(
              "div",
              { staticClass: "mx-0 col-lg-12" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "12 font-sm" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("settings.accountTab.remindersTabMsg")
                          ) +
                          "\n\n              "
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-switch p-fill float-right mt-1 mr-0",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isActive,
                                expression: "isActive",
                              },
                            ],
                            attrs: {
                              id: "reminders-active-id",
                              type: "checkbox",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.isActive)
                                ? _vm._i(_vm.isActive, null) > -1
                                : _vm.isActive,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.isActive,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isActive = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isActive = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isActive = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: { for: "reminders-active-id", hidden: "" },
                            },
                            [_vm._v("Active")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "state" }, [
                            _c(
                              "label",
                              {
                                staticClass: "mb-0 ml-1",
                                style: { marginTop: "1px" },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("global.words.enabled")) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex align-items-center",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-row",
                          { attrs: { "no-gutters": "" } },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "vertical-center",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "settings.accountTab.sendReminderAfter"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  "material-input",
                                  {
                                    attrs: {
                                      "label-for": "send-reminder-every-days",
                                      label: "Reminders",
                                      "hidden-label": true,
                                      "no-label": "",
                                    },
                                    model: {
                                      value: _vm.sendReminderEveryDays,
                                      callback: function ($$v) {
                                        _vm.sendReminderEveryDays = $$v
                                      },
                                      expression: "sendReminderEveryDays",
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.sendReminderEveryDays,
                                          expression: "sendReminderEveryDays",
                                        },
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: {
                                            mask: "9{0,3}",
                                            showMaskOnHover: false,
                                          },
                                          expression:
                                            "{ mask: '9{0,3}', showMaskOnHover: false }",
                                        },
                                      ],
                                      staticClass:
                                        "material-input form-control form",
                                      attrs: {
                                        id: "send-reminder-every-days",
                                        disabled: !_vm.isActive,
                                        autocomplete: "off",
                                        "data-lpignore": "true",
                                        type: "number",
                                        name: "sendReminderEveryDays",
                                      },
                                      domProps: {
                                        value: _vm.sendReminderEveryDays,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.sendReminderEveryDays =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { staticClass: "vertical-center" }, [
                              _c("p", { staticClass: "mb-0 text-lowercase" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$tc("global.words.day", 2)) +
                                    "\n                  "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }